import { ISetDarkMode } from "../models";
import { SET_DARK_MODE } from "../types";

export default (darkMode: boolean): ISetDarkMode => ({
    type: SET_DARK_MODE,
    payload: darkMode,
});
